import { useQuery } from '@tanstack/react-query';
import { request } from '@core/api/request';
import type { TApiResponse } from '@shared/types';
import type { TBankAccount } from '@shared/types/bank-account';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export const getBankInfo = async (): Promise<TApiResponse<TBankAccount>> => {
  return request({
    url: 'bank-accounts/',
  });
};

export const useGetBankInfo = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.getBankInfo],
    queryFn: async () => await getBankInfo(),
  });
};
